import React, { Component } from 'react' //eslint-disable-line
import PropTypes from 'prop-types'
import styled from 'styled-components'
import ListItem from './ListItem'

const ListContainer = styled.div`
  width: ${({ ghost }) => ghost ? 0 : '200px'};
  background-color: #D8D8D8;
  overflow-y: auto;
  border-top-right-radius:20px;
  border-bottom-right-radius:20px;
  padding-left: 10px;
  padding-right: 30px;
  padding-bottom: 20px;
  margin-top: 15px;
  box-sizing: border-box;
  opacity: ${({ ghost }) => ghost ? 0 : 1};
  @media (max-width: 1100px) {
    width: ${({ ghost }) => ghost ? 0 : '160px'};
  }
  @media (max-width: 763px) {
    display: none;
  }
`

class ClassRoomList extends Component {
  onClassroomClick = classroomId => this.props.onClassroomClick(classroomId)

  getTotalAndActiveStudents = () => {
    const { classrooms } = this.props
    let total = 0
    let activeStudents = 0

    if (classrooms.length > 0) {
      total = classrooms.filter(classroom => classroom.name !== 'Advenio Home').reduce((totalStudents, currentClassroom) => {
        activeStudents += currentClassroom.students
          .filter(student => (student.checkin && student.checkin.id !== null))
          .length
        return totalStudents + currentClassroom.enrolled_count
      }, 0)
    }

    return { total, activeStudents }
  }

  renderClassrooms() {
    return this.props.classrooms.map((classroom) => {
      const enrolledCount = classroom.enrolled_count
      const checkedInStudents = classroom.students
        .filter(({ checkin }) => (checkin && checkin.id !== null))

      let classroomType = classroom.type || 'inactive'

      if (this.props.activeClassroomId === classroom.id) {
        classroomType = 'active'
      }

      return (
        <ListItem
          icon={classroomType}
          name={classroom.name}
          context={`${checkedInStudents.length}/${enrolledCount}`}
          id={classroom.id}
          key={classroom.id}
          onItemClick={this.onClassroomClick}
          type={classroomType}
        />)
    })
  }

  render() {
    const headerContext = this.getTotalAndActiveStudents()

    if (this.props.userType === 'Teacher') {
      return <ListContainer ghost />
    }

    return (
      <ListContainer>
        <ListItem
          name="Salas"
          context={`${headerContext.activeStudents} / ${headerContext.total}`}
          isHeader
          id={1}
          onItemClick={() => null}
        />
        {this.renderClassrooms()}
      </ListContainer>
    )
  }
}

ClassRoomList.propTypes = {
  /** The listing of classrooms available in the current center */
  classrooms: PropTypes.array,
  /** The ID of the active classroom */
  activeClassroomId: PropTypes.number.isRequired,
  /** The role of the authenticated user */
  userType: PropTypes.string,
  /** Callback function to be fired when clicking a classroom in the list */
  onClassroomClick: PropTypes.func.isRequired,
}

ClassRoomList.defaultProps = {
  classrooms: [],
  userType: null,
}

export default ClassRoomList



// WEBPACK FOOTER //
// ./src/Components/ClassRoomList/index.jsx